import type { Card } from '../types/board';

interface CardOverlayProps {
  card: Card;
}

export function CardOverlay({ card }: CardOverlayProps): JSX.Element {
  return (
    <div className="w-72 rotate-3 cursor-grabbing rounded-lg border-2 border-blue-500 bg-white p-3 shadow-xl dark:bg-slate-800">
      <p className="whitespace-pre-wrap break-words text-sm font-medium text-slate-950 dark:text-slate-50">
        {card.content}
      </p>
      <div className="mt-2 flex items-center justify-between text-xs text-slate-600 dark:text-slate-300">
        <span>{card.author}</span>
      </div>
    </div>
  );
}
